// frontend/src/KutuphaneSayfasi.js
import React from 'react';
import { Outlet, NavLink } from 'react-router-dom'; // NavLink kullanıyoruz
import { Card } from 'react-bootstrap';
import './KutuphaneSayfasi.css'; // Yeni CSS dosyamızı import ediyoruz

function KutuphaneSayfasi() {
  return (
    <Card className="glass-card text-white">
      <Card.Header as="h2">Kütüphane Yönetimi</Card.Header>
      <Card.Body>
        {/* Bootstrap Tabs yerine kendi NavLink yapımız */}
        <div className="kutuphane-nav">
          <NavLink to="/kutuphane/besinler" className="kutuphane-nav-link">
            Besinler
          </NavLink>
          <NavLink to="/kutuphane/olcu-birimleri" className="kutuphane-nav-link">
            Ölçü Birimleri
          </NavLink>
          <NavLink to="/kutuphane/kategoriler" className="kutuphane-nav-link">
            Kategoriler
          </NavLink>
        </div>

        {/* Seçilen sekmeye ait içerik burada gösterilecek */}
        <Outlet />
      </Card.Body>
    </Card>
  );
}
export default KutuphaneSayfasi;